import React from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';
import Hidden from '@material-ui/core/Hidden';

import Orders from './Components/Orders';
import Sold from './Components/Sold';
import Trending from './Components/Trending';
import History from './Components/History';
import { minWidth } from '@material-ui/system';

const theme = createMuiTheme({
  palette: {
    type: 'dark',
  },
});

const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(4),
  },
  text: {
    padding: theme.spacing(1),
  },
});

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <React.Fragment>
      {value === index && <Box>{children}</Box>}
    </React.Fragment>
  );
}

function App(props) {
  const { classes } = props;
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <React.Fragment>
      <MuiThemeProvider theme={theme}>
        <Grid container spacing={2} className={classes.root}>
            <Hidden smDown>
              <Grid item xs={3}>
                <Paper className={classes.paper}>
                  <Typography>
                    Data polled every 15s from:
                  </Typography>
                  <Typography>
                    <Link href="https://tokentrove.com/" target="_blank" rel="noopener" rel="noreferrer" color="secondary">
                      TokenTrove
                    </Link>
                  </Typography>
                  <Typography>
                    <Link href="https://opensea.io//" target="_blank" rel="noopener" rel="noreferrer" color="secondary">
                      OpenSea
                    </Link>
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={9}>
                <Paper className={classes.paper}>
                  <Typography>
                    Hey all! I'm planning on adding more features in the future.
                  </Typography>
                  <Typography>
                    For feedback and suggestions use discord: FourShore#9099
                  </Typography>
                  <Typography>
                    If you'd like to contribute to this project you can send ETH to 0x91C20ef6477c4Ff9CfeCC48861E56c0dA1Dd37fD :)
                  </Typography>
                </Paper>
              </Grid>
            </Hidden>

            <Hidden smDown>
              <Grid item xs={3}>
                <Trending/>
              </Grid>         
            </Hidden>
            
            <Grid item xs style={{minWidth:'520px'}}>
              <AppBar position="static" color="inherit">
                <Tabs value={value} onChange={handleChange} aria-label="nav tabs">
                  <Tab label="Recent Listings"/>
                  <Tab label="Last Sold"/>
                  <Tab label="Volume History"/>
                </Tabs>
              </AppBar>
              <TabPanel value={value} index={0}>
                <Orders/>
              </TabPanel>
              <TabPanel value={value} index={1}>
                <Sold/>
              </TabPanel>
              <TabPanel value={value} index={2}>
                <History/>
              </TabPanel>
            </Grid>
        </Grid>
      </MuiThemeProvider>
    </React.Fragment>
  );
}

export default withStyles(styles)(App);
